import { render, staticRenderFns } from "./LocalSwitch.vue?vue&type=template&id=88f2d410&"
import script from "./LocalSwitch.vue?vue&type=script&lang=js&"
export * from "./LocalSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LocalSwitch.vue?vue&type=style&index=0&id=88f2d410&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports